<div class="row col-12 p-0 m-0 main-page-section">
  <div class="col-11 p-0 credit-details-section">
    <!-- <app-header></app-header> -->
    <div class="container-fluid div-height">
      <div class="credit-detail-header">
        <div class="row">
          <span class="prev-page pr-2 pointer-link"><a routerLink="/overview">Home</a></span>
          <span class="separator">></span>
          <span class="curr-page pl-2 pointer-link"><a [ngStyle]="{'cursor': 'pointer'}" routerLink="/credits">Credit
              Points</a></span>
          <!--  -->
          <span class="separator pr-2 pl-2">></span>
          <span class="curr-page pl-2"><a>Organisation Detail</a></span>
        </div>

        <div class="row row-1">
          <h5 *ngIf="tenantCompanyName !== null; else noTenantName">{{tenantCompanyName}}</h5>
          <ng-template #noTenantName>NA</ng-template>
        </div>

        <div class="row row-2">
          <span *ngIf="tenantCompanyAddress !== null; else noCity">{{tenantCompanyAddress}}</span>
          <ng-template #noCity>NA</ng-template>
        </div>
      </div>


      <div class="row row-3">
        <div class="col-sm-4 ">
          <p>Total Credit Points</p>
          <p class="output">{{getTotalCredit(orgTenant)}}</p>
        </div>
        <div class="col-sm-4">
          <p>Complimentary</p>
          <p class="output">
            {{getTenantTotalCredit(orgTenant, 'spent',
            1)}}/{{getTenantTotalCredit(orgTenant, 'total', 1)}}
            balance</p>

        </div>
        <div class="col-sm-4">
          <p>Purchased</p>
          <p class="output">
            {{getTenantTotalCredit(orgTenant, 'spent',
            2)}}/{{getTenantTotalCredit(orgTenant, 'total', 2)}}
            balance</p>

        </div>
      </div>


      <div class="row r-4">

        <div class="col-7 box">

          <div class="block-1">
            <!-- <p>Member Name</p>
            <select (change)="searchUser($event.target.value, 'select')">
              <option>All</option>
              <ng-container *ngIf="tenantUsers && tenantUsers.length>0 && tenantUsers !== undefined; else noTenantUser">
                <option *ngFor="let list of tenantUsers" value="{{list.userId}}">{{list.userName}}</option>
              </ng-container>
              <ng-template #noTenantUser>
                <option>none</option>
              </ng-template>
            </select> -->


            <div class="d-flex " [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p="ngbPopover"
              (click)="openPopover(p)" (clickOutside)="onClickedOutside($event)" placement="bottom"
              popoverClass='dash-popover dashboard-popover'
              class=" borders-right padding-left-meeting organization select-box pointer-link">
              Member Name
              <span class="d-flex justify-content-end pointer-link"><img src="/assets/images/Path.png"
                  class="padding-left-image pr-3 justify-content-between" /></span>

              <div class="all pointer-link">{{selectedTenantName}} <span
                  *ngIf="multiSelecttenant.length > 1">+{{multiSelecttenant.length - 1}}</span></div>

              <div>
                <ng-template #popContent>
                  <div class="dashboard-popover ">
                    <div class="d-flex justify-content-between ">
                      <div>
                        <div class="row pb-2 pointer-link">

                          <div class="popover-content pl-3 pr-3 email-width col-11"
                            (click)="selectEmailid({userId:null, userName:'All'})"
                            [class]="multiSelecttenant.includes(null)?'bold-font':'normal-font'">
                            All
                          </div>
                          <div class="col-1">
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelecttenant.includes(null) || (multiSelecttenant.length == 0)" class=""
                              loading="lazy" />

                          </div>
                        </div>
                        <div class="row pb-2 pointer-link" *ngFor="let list of tenantUsers;let i=index">

                          <div class="popover-content pl-3 pr-3 email-width col-11" (click)="selectEmailid(list)"
                            [class]="multiSelecttenant.includes(list?.userId)?'bold-font':'normal-font'">
                            {{maskName(list?.userName)}}
                          </div>
                          <div class="col-1">
                            <img src="/assets/images/tick.png"
                              *ngIf="multiSelecttenant.includes(list?.userId) || (list.userId == null && multiSelecttenant.length == 0)"
                              class="" loading="lazy" />

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
          <div class="block-2">
            <img src="../../../assets/images/search.png">
            <input type="search" placeholder="Type here to search..." [(ngModel)]="searchTerm" (keyup)="startSearch()">
          </div>
        </div>
      </div>

      <ng-container *ngIf="tenantUser && tenantUser.length>0 && tenantUser !== undefined; else noTenantUserList">
        <div class="row r-5 " *ngFor="let list of tenantUser | filter:searchTerm | paginate: { itemsPerPage: 10,
          currentPage: page,
          totalItems:tenantUser?.length }">
          <div class="col-sm-1">
            <img src="{{list.profileUri}}" alt="User" *ngIf="list.profileUri; else user">
            <ng-template #user>
              <p class="icon">{{generateInitials(list?.userName)}}</p>
            </ng-template>
          </div>
          <div class="col=sm-4">
            <p class="name">{{maskName(list.userName)}}</p>
            <div><img class="group" src="../../../assets/images/credit-small.png">
              <p class="creditPoint pl-3">Credit Points Used : {{list.creditsUsed}}</p>
            </div>
          </div>
        </div>
        <!-- <div class="row r-6" *ngIf="showPagination">
          <ngb-pagination [collectionSize]="tenantUsers.length" [maxSize]="5" [(page)]="page" [pageSize]="pageSize"
            (pageChange)=refreshPagination()>
          </ngb-pagination>
        </div> -->
      </ng-container>
      <ng-template #noTenantUserList>
        <div class="row r-5 ">
          No Users Found
        </div>
      </ng-template>
      <div class="d-flex justify-content-center mt-4 mb-4" style="margin:30px 0px"
        *ngIf="tenantUser?.length > pageSize">
        <div class="row d-flex pagination-border">
          <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)" nextLabel=""
            class="d-flex justify-content-center">
          </pagination-controls>
          <div class="pr-3 ratio-class pt-1">
            {{tenant?.length}}/{{tenantUser?.length}}</div>
        </div>
      </div>
    </div>
  </div>
</div>